import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Lightbox } from 'ngx-lightbox';
import { NgxSpinnerService } from "ngx-spinner";
import { Subscription } from 'rxjs';
import 'rxjs/add/operator/switchMap';
import { AppSettingsService } from '../../../../shared/services/appsettings.service';
import { ContestWinnerModel } from '../../models/contestWinner.model';
import { ContestService } from '../../services/contest.service';

@Component({
  selector: 'winners',
  templateUrl: './winners.component.html',
  styleUrls: ['./winners.component.css']
})

@Injectable()
export class WinnersComponent implements OnInit, OnDestroy {

  subscription: Subscription
  contestWinners: ContestWinnerModel[];
  gradeKTo2Winners: ContestWinnerModel[];
  grade3To5Winners: ContestWinnerModel[];
  grade6To8Winners: ContestWinnerModel[];
  grade9To12Winners: ContestWinnerModel[];
  bestOfShow: ContestWinnerModel;
  gradeKTo2Label: string;
  grade3To5Label: string;
  grade6To8Label: string;
  grade9To12Label: string;

  constructor(private _contestService: ContestService,
    private _lightbox: Lightbox,
    private _spinner: NgxSpinnerService,
    private route: ActivatedRoute) {

  }

  ngOnInit() {
    this.gradeKTo2Label = AppSettingsService.settings.gradeKTo2Label;
    this.grade3To5Label = AppSettingsService.settings.grade3To5Label;
    this.grade6To8Label = AppSettingsService.settings.grade6To8Label;
    this.grade9To12Label = AppSettingsService.settings.grade9To12Label;

    this.subscription = this.route.paramMap
      .switchMap(params => this._contestService.getWinners(params.get('year')))
      .subscribe(
        (response: ContestWinnerModel[]) => {
          this.contestWinners = response;

          this.bestOfShow = _.find(this.contestWinners, function (w) {
            if (w.voteChoiceTypeId == AppSettingsService.settings.bestOfShowChoiceTypeId) return w;
          });

          this.gradeKTo2Winners = _.filter(this.contestWinners, function (w) {
            if (w.gradeCategoryId == AppSettingsService.settings.gradeCategoryIdKTo2) return w;
          });

          this.grade3To5Winners = _.filter(this.contestWinners, function (w) {
            if (w.gradeCategoryId == AppSettingsService.settings.gradeCategoryId3To5) return w;
          });

          this.grade6To8Winners = _.filter(this.contestWinners, function (w) {
            if (w.gradeCategoryId == AppSettingsService.settings.gradeCategoryId6To8) return w;
          });

          this.grade9To12Winners = _.filter(this.contestWinners, function (w) {
            if (w.gradeCategoryId == AppSettingsService.settings.gradeCategoryId9To12) return w;
          });
        },
        error => {
          this._spinner.hide()
        },
        () => this._spinner.hide()
      );
  }

  open(item): void {
    let items: Array<any> = [{ src: item.pictureName, thumb: item.pictureThumbName }];
    this._lightbox.open(items, 0);
  }

  close(): void {
    this._lightbox.close();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}
